import "./index_page.css";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const scroll_down_button = document.getElementById(
      "index_page_scroll_down",
    );
    const index_page_second_screen = document.getElementById(
      "index_page_second_screen",
    );

    if (!scroll_down_button) return;

    scroll_down_button.addEventListener("click", () => {
      index_page_second_screen.scrollIntoView();
    });

    const open_video_modal = document.getElementById("open_video_modal");
    const video_modal = document.getElementById("video_modal");
    const video_modal_video = document.getElementById("video_modal_video");
    const video_modal_content = document.getElementById("video_modal_content");

    open_video_modal.addEventListener("click", () => {
      video_modal.classList.add("video_modal_open");
      video_modal_video.play();
    });

    video_modal_content.addEventListener("click", (event) => {
      event.stopPropagation();
    });

    video_modal.addEventListener("click", (event) => {
      video_modal.classList.remove("video_modal_open");

      setTimeout(() => {
        video_modal_video.pause();
        video_modal_video.currentTime = 0;
      }, 900);
    });
  },
  false,
);
